import { GetInAppNotificationsInDto, GetInAppNotificationsOutDto } from '../../../types/in-app-notification.dto';

export const GET_IN_APP_NOTIFICATIONS = 'GET_IN_APP_NOTIFICATIONS';
export const GET_IN_APP_NOTIFICATIONS_SUCCESS = 'GET_IN_APP_NOTIFICATIONS_SUCCESS';
export const GET_IN_APP_NOTIFICATIONS_ERROR = 'GET_IN_APP_NOTIFICATIONS_ERROR';
export const RESET_IN_APP_NOTIFICATIONS = 'RESET_IN_APP_NOTIFICATIONS';

export interface GetInAppNotifications {
  type: typeof GET_IN_APP_NOTIFICATIONS;
  payload: GetInAppNotificationsOutDto;
}

export interface GetInAppNotificationsSuccess {
  type: typeof GET_IN_APP_NOTIFICATIONS_SUCCESS;
  payload: GetInAppNotificationsInDto;
  append: boolean;
}

export interface GetInAppNotificationsError {
  type: typeof GET_IN_APP_NOTIFICATIONS_ERROR;
  payload: string | boolean;
}

export interface ResetInAppNotifications {
  type: typeof RESET_IN_APP_NOTIFICATIONS;
  payload: null;
}

export interface State {
  data: GetInAppNotificationsInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | GetInAppNotifications
  | GetInAppNotificationsSuccess
  | GetInAppNotificationsError
  | ResetInAppNotifications;
